import React from 'react';

import { GroupOrderShareScreen } from '../../../../screens/GroupOrderShareScreen';

// ─────────────────────────────────────────────────────────────────────────────

export default function GroupOrderShareRoute() {
  return <GroupOrderShareScreen />;
}
